import React, { useState } from "react";
import { Settings, Zap } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

interface ChatSettingsProps {
  streaming: boolean;
  onStreamingChange: (streaming: boolean) => void;
  temperature: number;
  onTemperatureChange: (temperature: number) => void;
}

export const ChatSettings: React.FC<ChatSettingsProps> = ({
  streaming,
  onStreamingChange,
  temperature,
  onTemperatureChange,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button variant='ghost' size='sm' className='p-2' title='Chat Settings'>
          <Settings className='h-5 w-5' />
        </Button>
      </DialogTrigger>
      <DialogContent className='sm:max-w-md'>
        <DialogHeader>
          <DialogTitle>Chat Settings</DialogTitle>
        </DialogHeader>
        <div className='space-y-4'>
          {/* Streaming Toggle */}
          <div className='flex items-center justify-between'>
            <div className='flex items-center space-x-2'>
              <Zap className='h-4 w-4 text-muted-foreground' />
              <Label htmlFor='streaming' className='text-sm'>
                Streaming
              </Label>
            </div>
            <Button
              onClick={() => onStreamingChange(!streaming)}
              variant={streaming ? "default" : "outline"}
              size='sm'
              className='h-6 w-11 p-0'
            >
              <span
                className={`inline-block h-4 w-4 transform rounded-full bg-background transition-transform ${
                  streaming ? "translate-x-6" : "translate-x-1"
                }`}
              />
            </Button>
          </div>

          {/* Temperature Slider */}
          <div className='space-y-2'>
            <div className='flex items-center justify-between'>
              <Label htmlFor='temperature' className='text-sm'>
                Temperature
              </Label>
              <span className='text-sm text-muted-foreground'>
                {temperature}
              </span>
            </div>
            <Input
              type='range'
              min='0'
              max='2'
              step='0.1'
              value={temperature}
              onChange={(e) => onTemperatureChange(parseFloat(e.target.value))}
              className='w-full'
            />
            <div className='flex justify-between text-xs text-muted-foreground'>
              <span>Focused</span>
              <span>Creative</span>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
